import { api } from "../utils/api";
import UserStore from "../utils/UserStore";

export const NEW_STAGE_ID = "new";

const normalizeLink = link => ({
  idTurmaDisc: String(link.idTurmaDisc),
  classId: String(link.classCode || ""),
  className: String(link.classCode || ""),
  disciplineName: link.disciplineName || String(link.idTurmaDisc)
});

const normalizeStage = stage => ({
  ...stage,
  links: Array.isArray(stage.links) ? stage.links.map(normalizeLink) : []
});

const getConcepts = async () => {
  const res = await api.get("ClassDiaryV1/class-stages/concepts");
  const data = res.data || {};
  return {
    groupTitle: data.groupTitle || "",
    concepts: Array.isArray(data.concepts) ? data.concepts : []
  };
};

const getStages = async classId => {
  const res = await api.get(
    `ClassDiaryV1/class-stages/${encodeURIComponent(classId)}`
  );
  const data = res.data || {};
  return {
    periods: Array.isArray(data.periods) ? data.periods : [],
    stages: Array.isArray(data.stages) ? data.stages.map(normalizeStage) : []
  };
};

const saveStage = async (classId, stage) => {
  const res = await api.post(
    `ClassDiaryV1/class-stages/${encodeURIComponent(classId)}`,
    {
      externalData: UserStore.getUserExternalInfo(),
      id: stage.id || undefined,
      periodCode: stage.periodCode,
      title: stage.title,
      description: stage.description,
      concepts: stage.concepts,
      links: stage.links.map(link => ({
        classId: link.classId,
        idTurmaDisc: link.idTurmaDisc
      }))
    }
  );
  return res.data;
};

export default {
  getConcepts,
  getStages,
  saveStage
};
